import React from "react";

import { DocScanComparisonRow } from "pages/admin/verifications/utils/docScanEvidenceDrawer";

export const DocScanComparisonTable = ({ rows }: { rows: DocScanComparisonRow[] }) => (
  <table className="doc-scan-comparison">
    <thead>
      <tr>
        <td />
        <th scope="col">Document</th>
        <th scope="col">Platform</th>
      </tr>
    </thead>
    <tbody>
      {rows.map(({ key, label, documentValue, platformValue, platformValueAtScan, sizeVariance, tone }) => (
        <tr key={key} className={tone}>
          <th scope="row">{label}</th>
          <td className="doc-scan-document-value">{documentValue}</td>
          <td>
            <span className="doc-scan-platform-value">
              {platformValue}
              {sizeVariance && <span className="doc-scan-size-variance">{sizeVariance}</span>}
            </span>
            {platformValueAtScan && <div className="doc-scan-value-at-scan">{platformValueAtScan} when scanned</div>}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
